import React from 'react';
import InteractionEnumIcon from '@/components/common/InteractionEnumIcon';
import InteractionType from '@/constants/InteractionType';
import translate from '@/lib/intl/translate';
import { EmailParticipants } from '@/modules/Comms';
import EntityDate from './EntityDate';

const CLASSES = {
  interaction: {
    icon: 'inline',
  },
};

type EmailIntegrationSentSummaryProps = {
  entity: unknown | unknown;
};

export default function EmailIntegrationSentSummary({
  entity,
}: EmailIntegrationSentSummaryProps) {
  const {
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'bccRecipients' does not exist on type 'u... Remove this comment to see the full error message
    bccRecipients = [],
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'ccRecipients' does not exist on type 'un... Remove this comment to see the full error message
    ccRecipients: [ccRecipient, ...otherCcRecipients] = [],
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'commsId' does not exist on type 'unknown... Remove this comment to see the full error message
    commsId,
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'messageDatetime' does not exist on type ... Remove this comment to see the full error message
    messageDatetime,
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'toRecipients' does not exist on type 'un... Remove this comment to see the full error message
    toRecipients = [],
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'sender' does not exist on type 'unknown'... Remove this comment to see the full error message
    sender,
  } = entity;

  const interactionIcon = (
    <InteractionEnumIcon
      classes={CLASSES.interaction}
      enumValue={InteractionType.EMAIL}
      iconOnly
      type={InteractionEnumIcon.interactionType}
    />
  );

  const isBccOnly = bccRecipients.length && !toRecipients.length;

  return (
    <span className="font-normal">
      {isBccOnly
        ? translate('EMAIL_INTEGRATION_SENT_BCC_ONLY_SUMMARY', {
            sender: <EmailParticipants participants={sender} showAll />,
            interactionIcon,
            bccRecipients: <EmailParticipants participants={bccRecipients} />,
            date: (
              <EntityDate entityId={commsId} dateString={messageDatetime} />
            ),
          })
        : translate('EMAIL_INTEGRATION_SENT_SUMMARY', {
            sender: <EmailParticipants participants={sender} showAll />,
            hasCcRecipient: !!ccRecipient,
            showMoreCcRecipients: !!otherCcRecipients.length,
            otherCcRecipientsCount: otherCcRecipients.length,
            ...(ccRecipient && {
              ccRecipient: (
                <EmailParticipants participants={ccRecipient} showAll />
              ),
            }),
            date: (
              <EntityDate entityId={commsId} dateString={messageDatetime} />
            ),
            interactionIcon,
            recipientsPlus: toRecipients.length > 3,
            recipientsPlusNumber: toRecipients.length - 3,
            recipients: (
              <EmailParticipants
                participants={toRecipients.slice(0, 3)}
                showAll
              />
            ),
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any, react/no-unstable-nested-components -- TODO(ts-migrate), TODO(ts-migrate) */
            strong: (...text: any[]) => <strong>{text}</strong>,
          })}
    </span>
  );
}
